import React from 'react';

const defaultPageContext = {
    setPageName: () => {},
    refreshClinician: () => {},
};

const PageContext = React.createContext(defaultPageContext);
export default PageContext;
